import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { Physician } from "src/app/models/physician";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: "app-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["./feedback.component.css"],
})
export class FeedbackComponent implements OnInit {
  aptId: any;
  physician: Physician;
  ratingForm: UntypedFormGroup;
  physician_model: any = {};
  specialitiesList: any = [];
  currentRate: any;
  physicianRating: any;
  sooperDrRating: any;
  physicianData: any = {};
  sooperDrData: any = {};
  states: any = [];
  dateFormat = Utils.DATE_FORMAT;
  feedbackType = Utils.FEEDBACK_TYPE;
  feedbackColors = Utils.FEEDBACK_COLORS;
  physicianFeedbackComments: any;
  SooperDrFeedbackComments: any;
  starSize = Utils.STAR_SIZE;
  defaultDr = Utils.DEFAULTDR;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.aptId = this.route.snapshot.queryParams["aptid"];
    this.getPhysician();
    this.ratingForm = this._formBuilder.group({
      physicianRatingComment: [""],
      sooperDrRatingComment: [""],
    });
    this.ratingForm.patchValue({
      physicianRatingComment: this.physicianFeedbackComments,
      sooperDrRatingComment: this.SooperDrFeedbackComments,
    });
    console.log(this.ratingForm);
  }

  getPhysician() {
    this.service
      .getPhysicianById(this.route.snapshot.queryParams["drid"])
      .subscribe(
        (res) => {
          this.physician = res;

          if (
            this.physician &&
            this.physician.physician_qualification &&
            this.physician.physician_qualification.length
          ) {
            this.physician.qualification =
              this.physician.physician_qualification[0].qualification;
          }

          if (
            this.physician &&
            this.physician.physician_education &&
            this.physician.physician_education.length
          ) {
            this.physician_model.education = this.physician.physician_education
              .map((x) => x.degree)
              .join(", ");
            this.physician_model.university = this.physician.physician_education
              .map((x) => x.institution)
              .join(", ");
          }

          if (
            this.physician &&
            this.physician.physician_speciality &&
            this.physician.physician_speciality.length
          ) {
            this.getSpecialitiesList();
          }

          if (this.physician && this.physician.state) {
            this.loadStates();
          }
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          let msg =
            error && error.error && error.error.message
              ? error.error.message
              : "Something went wrong. Please try again.";
          this.showToast("error", msg);
        }
      );
  }

  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
        //Map Specialities
        let specialities = [];
        this.physician.physician_speciality.forEach((element) => {
          let sp = this.specialitiesList.find(
            (s) => s.id == element.speciality_id
          );
          specialities.push(`${sp.name} - ${element.no_of_years}Years`);
        });
        this.physician_model.speciality = specialities.join(", ");
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  loadStates() {
    this.service.getStates(1).subscribe((res) => {
      this.states = res;
      this.physician_model.location = this.states.find(
        (x) => x.id == this.physician.state
      );
      this.physician_model.location = ", " + this.physician_model.location.name;
    });
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  submitFeedback() {
    let pRating = {
      aptid: this.aptId,
      ratings: this.physicianRating,
      type: this.feedbackType?.PHYSICIAN,
      comments: this.ratingForm?.value?.physicianRatingComment,
    };
    let sRating = {
      ratings: this.sooperDrRating,
      type: this.feedbackType?.SOOPERDR,
      comments: this.ratingForm?.value?.sooperDrRatingComment,
    };

    this.physicianData = Utils.removeNullAndEmpty(pRating);
    this.sooperDrData = Utils.removeNullAndEmpty(sRating);

    let data = new Physician();
    data.u_id = this.route.snapshot.queryParams["drid"];
    data.feedbacks = [{ ...this.physicianData }, { ...this.sooperDrData }];
    this.spinner.show();
    this.service
      .updatePhysician(this.route.snapshot.queryParams["drid"], data)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.showToast("success", "Feedback sent successfully");
          // setTimeout(() => {
          // let url = Utils.homePageUrl;
          // window.open(url, "_self");
          // }, 2000);
          let url = Utils.homePageUrl;
          window.open(url, "_self");

        },
        (error) => {
          console.log(error);
          this.spinner.hide();
          let msg =
            error && error.error && error.error.message
              ? error.error.message
              : "Something went wrong. Please try again.";
          this.showToast("error", msg);
        }
      );
  }
}
